var defaultMapOptions = {
    zoom: 7,
    scrollwheel: true,
    fullscreenControl: false,
    gestureHandling: 'greedy',
    zoomControl: false,
    streetViewControl: false,
    mapTypeControl: false,
    minZoom: 6
};
export default defaultMapOptions;
//# sourceMappingURL=defaultMapOptions.js.map